<template>
  <div id="pay-success">
    <img src="../assets/images/memberPurchase/success.png" alt="">
    <div>
      <p>您已成为锦鲤保</p>
      <p>第<span>{{vip}}</span>位会员</p>
    </div>
    <button @click="toMy">前往个人中心</button>
  </div>
</template>

<script>
// 购买成功
export default {
  name: 'paySuccess',
  data() {
    return {
      vip: 0
    }
  },
  methods: {
    toMy(){
      this.$router.push('/personal')
    }
  },
  created(){
    this.vip = this.$route.query.vip
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
  #pay-success{
    background: #fff;
  }
  #pay-success > div{
    text-align: center;
    margin: 3rem 0 4rem;
    font-size: 1.1rem;
    line-height: 1.81rem;
  }
  #pay-success > div p span{
    font-size: 1.6rem;
    margin: 0 0.1875rem;
  }
  #pay-success button{
    display: block;
    margin: 0 auto;
    width: 21.875rem;
    height: 2.8125rem;
    line-height: 2.8125rem;
    color: #fff;
    font-size: 1.1rem;
    font-weight: 500;
    /* font-family: 'AlibabaPuHuiTi-Medium'; */
    background:#FF9024;
    box-shadow: 0 0.3125rem 0.5625rem 0 rgba(245,130,18,0.27);;
    border-radius: 1.4375rem;
  }
</style>